import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import MenuLateral from './MenuLateral';
import '../styles/AdminLayout.css';

const AdminLayout = ({user}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div className="admin-layout">
      <button className="hamburger-menu" onClick={toggleMenu}>
        ☰
      </button>
      <MenuLateral isMenuOpen={isMenuOpen} />
      <div className="contenido-principal">
        <Outlet context={{user}} />
      </div>
    </div>
  );
};

export default AdminLayout;